import StudentsPage from './StudentsPage.container';

export default StudentsPage;
